import { Component, inject } from '@angular/core';

import { GlobalVariablesService } from '../../services/global-variables.service';

@Component({
    selector: 'pcg-isrefrigerated-tooltip',
    templateUrl: './isrefrigerated-tooltip.component.html',
    styleUrls: ['./isrefrigerated-tooltip.component.scss'],
    standalone: false
})
export class IsrefrigeratedTooltipComponent { gvs = inject(GlobalVariablesService); }
